<template>
  <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="接待讲解" class="h-100" name="2">
      <reception-explain v-if="activeName == 2"></reception-explain>
    </el-tab-pane>
    <el-tab-pane label="预约讲解" class="h-100" name="3">
      <appoint-explain  v-if="activeName == 3"></appoint-explain>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import receptionExplain from './reception-explain'
import appointExplain from './appoint-explain'

export default {
  components: {
    receptionExplain,
    appointExplain
  },
  data() {
    return {
      activeName: "2",
      list: []
    }
  },

  methods: {
    handleClick(tab) {
      this.activeName = tab.name
    },
  },

  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.el-tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
  /deep/ .el-tabs__header{
    margin-bottom: 0;
    background: #fff;
  }
  /deep/.el-tabs__nav-wrap {
    &::after {
      display: none;
    }
    .el-tabs__nav-scroll {
      display: flex;
      justify-content: center;
    }
  }

  /deep/.el-tabs__content {
    flex: 1;
    overflow: auto;
    padding-bottom: 50px;
  }
}
</style>